/* import __COLOCATED_TEMPLATE__ from './confirmation-modal.hbs'; */
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { assert } from '@ember/debug';
import Component from '@ember/component';

/**

## Overview

Simple modal that shows a title, message, and Confirm/Cancel buttons.
Returns a promise resolves to true when the submit button or <enter> key
is pressed.

## Usage

```javascript
modal: Ember.inject.service(),

actions: {
  delete() {
    this.modal.open(ModalsConfirmationModal, {
      titleText: 'Are you sure?',
      bodyText: 'This cannot be undone.',
      submitButtonText: t('button.confirm'),
      cancelButtonText: t('button.cancel'),
      isWarning: true
    }).then(confirmed => {
      if (confirmed) {
        deleteEverything();
      }
    });
  }
}
```

@param {String} titleText - Localized modal title.
@param {String} bodyText - Localized modal body.
@param {String} component - A component to use instead of `bodyText`.
  It will get `modalOptions` and `close` passed to it.
@param {String} submitButtonText - Submit button label, defaults to "Confirm".
@param {Boolean} isWarning - Submit button is red when true.
@param {String} cancelButtonText - Cancel button label, defaults to "Cancel".

*/

export default class ConfirmationModal extends Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "modalOptions", void 0);
    _defineProperty(this, "close", void 0);
    _defineProperty(this, "setCloseHandler", void 0);
    _defineProperty(this, "hasDividers", true);
  }
  get submitLabel() {
    return this.modalOptions.submitButtonText;
  }
  get cancelLabel() {
    return this.modalOptions.cancelButtonText;
  }
  get isWarning() {
    return this.modalOptions.isWarning;
  }
  didReceiveAttrs() {
    super.didReceiveAttrs();
    super.didReceiveAttrs();
    assert('You must pass a translated `modalOptions.submitButtonText` string when using `{{confirmation-modal}}`', this.submitLabel);
  }
}